export const PlatformReferralRoute = {
  VIEWS: {
    name: 'views',
    path: 'views'
  },
  FREE_WILL_REFERRALS: {
    name: 'free-will-referrals',
    path: 'free-will-referrals'
  }
};
